module.exports = require('./helpers/bundle-url').getBundleURL('7EiNB') + "bg.5ea1a05b.webm";